var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.742 8H6.258a2 2 0 0 0-1.996 2.125l.5 8A2 2 0 0 0 6.758 20h10.484a2 2 0 0 0 1.996-1.875l.5-8A2 2 0 0 0 17.742 8ZM6.258 6a4 4 0 0 0-3.992 4.25l.5 8A4 4 0 0 0 6.758 22h10.484a4 4 0 0 0 3.992-3.75l.5-8A4 4 0 0 0 17.742 6H6.258Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7a5 5 0 0 1 10 0v2a1 1 0 1 1-2 0V7a3 3 0 1 0-6 0v2a1 1 0 0 1-2 0V7Z",
    fill: "#777E91"
  })));
};
export default SvgLine;